import { render, staticRenderFns } from "./ApuracaoFluxo.vue?vue&type=template&id=20aa5cb3"
import script from "./ApuracaoFluxo.vue?vue&type=script&lang=js"
export * from "./ApuracaoFluxo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports